var render = function render(){var _vm=this,_c=_vm._self._c;return _c('secgroup-list',{ref:"secgroupList",attrs:{"hiddenActions":['openSecgroupSidepageTab'],"hiddenColumns":['guest_cnt'],"hiddenSidepageTabs":['vminstance-list'],"id":_vm.id,"getParams":_vm.getParams,"show-create-action":false,"customSingleActions":_vm.customSingleActions,"frontGroupMethods":"coverage","frontGroupActions":_vm.frontGroupActions}})
}
var staticRenderFns = []

export { render, staticRenderFns }